import React from "react";
import "./accueil.css";
import { Link } from "react-router-dom";
import bg_image_1 from "../../images//img/Resume folder-cuate.svg";
import bg_image_2 from "../../images/img/Resume folder-amico.svg";
import {
  LogIn,
  UserRoundPen,
  CircleCheck,
  UserRoundSearch,
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
} from "lucide-react";
import favicon from "../../images/favicon.png";

class Accueil extends React.Component {
  render() {
    return (
      <>
        <header className="bg-w">
          <nav className="navbar fixed-top bg-body-tertiary bg-w adminx-container-navbar-phone">
            <div className="container-fluid justify-center-phone">
              <a className="navbar-brand">
                <img
                  src={favicon}
                  className="navbar-brand-image d-inline-block align-top mr-2"
                  alt=""
                />{" "}
                CVthèque
              </a>
              <div className="d-flex">
                <Link to="/formulaire" className="btn btn-outline-dark mr-2 bg-w-p">
                  <UserRoundPen /> S'incrire
                </Link>
                <Link
                  to="/se-connecter"
                  className="btn btn-outline-success mr-3 bg-w-p"
                >
                  <LogIn /> Se connecter
                </Link>
              </div>
            </div>
          </nav>
        </header>

        <main className="main_acc_white">
          <div className="container-xl pt-7">
            <div className="row pb-5">
              <div className="">
                <div className="h-100">
                  <div className="row align-items-center h-100">
                    <div className="col-lg-8 py-3 wow fadeInUp text-center-phone">
                      <h1 className="mb-4 titre p-2">
                        Vous arrive-t-il de passer des heures à trier des CV
                        sans trouver le candidat idéal ?
                      </h1>
                      <p className="text-lg mb-5 parf p-2">
                        Souhaitez-vous maximiser vos chances de recruter les
                        meilleurs talents rapidement et facilement ? <br />
                        Vous en avez marre de perdre du temps et de l'argent
                        dans des recrutements infructueux ?
                      </p>

                      <Link to="/formulaire" className="btn btn-acc ml-2">
                        <UserRoundSearch /> Recruteur
                      </Link>
                      <Link to="/form-candidat" className="btn btn-warning ml-2">
                        <UserRoundPen /> Candidat
                      </Link>
                    </div>
                    <div className="col-lg-4 py-3 wow zoomIn d-none-phone">
                      <div className="img-place">
                        <img
                          src={bg_image_1}
                          alt=""
                          className="img-fluid w-100"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section className="accueil_sect_gry pt-5">
            <div className="container-xl">
              <div className="row">
                <div className="col-lg-4 d-none-phone">
                  <img src={bg_image_2} alt="" className="img-fluid w-100" />
                </div>
                <div className="col-lg-8">
                  <h2 className="color-b">Plus besoin de trier des centaines de CV.</h2>
                  <p>
                    Notre CVthèque centralise des CV qualifiés et vous offre des
                    outils de recherche puissants pour trouver les meilleurs
                    talents en un clin d'œil. Notre CVthèque, c'est la solution
                    pour un recrutement efficace et performant. Contactez-nous
                    dès aujourd'hui et optimisez vos chances de trouver la perle
                    rare !
                  </p>
                  <hr />
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      <CircleCheck color="#142352" /> <b>Filtres précis :</b> ciblez
                      les candidats répondant parfaitement à vos besoins.
                    </li>
                    <li className="list-group-item">
                      <CircleCheck color="#142352" /> <b>Recherche avancée :</b>
                      trouvez des compétences rares en quelques clics.
                    </li>
                    <li className="list-group-item">
                      <CircleCheck color="#142352" /> <b>Gain de temps :</b> passez
                      moins de temps à chercher, plus à recruter !
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <section></section>
          <footer className="pt-5">
            <div className="container-xl text-center">
              <div className="row justify-content-center">
                <p>
                  <img
                    src={favicon}
                    className="navbar-brand-image d-inline-block align-top mr-2"
                    alt=""
                  />
                </p>
              </div>
              <div className="row justify-content-center">
                <p>© 2024 CVthèque.</p>
              </div>
              <div className="row justify-content-center pb-5">
                <span className="mr-2">
                  <Link to="#" className="btn">
                    <Facebook size="20" color="#142352" />
                  </Link>
                </span>
                <span className="mr-2">
                  <Link to="#" className="btn">
                    <Instagram size="20" color="#142352" />
                  </Link>
                </span>
                <span className="mr-2">
                  <Link to="#" className="btn">
                    <Linkedin size="20" color="#142352" />
                  </Link>
                  <Link to="#" className="btn">
                    <Twitter size="20" color="#142352" />
                  </Link>
                </span>
              </div>
            </div>
          </footer>
        </main>
      </>
    );
  }
}

export default Accueil;
